import { CptClient, Photo, GenEnt } from './types';

export const getCptClients = async (): Promise<CptClient[]> => {
  const res = await fetch('/json/api/cpt/export?data=client');
  const data = await res.text();
  const myClients = data.split('\n');
  myClients.shift();
  const parsedClients = myClients.map((c) => c.split(';'));
  const mappedClient = parsedClients.map((c) => {
    return {
      id: parseInt(c[0]),
      societe: c[1],
      region: c[2],
      email: c[4],
    };
  });
  return mappedClient;
};

export const getPhotos = async (): Promise<Photo[]> => {
  const res = await fetch('/api/photos');
  const data = await res.text();
  const photos = JSON.parse(data);

  return photos.payload;
};

export const getGenEnts = async (): Promise<GenEnt[]> => {
    const res = await fetch('/api/gen-ent/');
    const data = await res.text();
    const genEnts = JSON.parse(data);
  
    return genEnts.payload;
  };